module.exports = __webpack_public_path__ + "img/brackets_right_layout_icon.9a8fdf5b.svg";